module.exports = __webpack_public_path__ + "images/87bdc6d93aa0ff9e4ec0f26cd4ba3c98-logo_beta.png";